module.exports = __webpack_public_path__ + "img/operation-see-title.7a9e263f.png";